import { Outlet } from 'react-router-dom';
import ClerkWrapper from './ClerkWrapper';

export default function ClerkLayout() {
  return (
    <ClerkWrapper>
      <Outlet />
    </ClerkWrapper>
  );
}